import React, { useRef } from 'react';
import { useDrop, DndProvider, useDrag } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SinglePackUnit from './SinglePackUnits';
import MultiSingleSizePackUnit from './MultiSingleSizePackUnit';
import MultiSizePackUnits from './MultiSizePackUnits';
import MultiDestinationPackUnits from './MultiDestinationPackUnits';

function SizeQuantityandPrices({ data, fromForm, forSwitch, index, dropLocation, lengthEnabled }) {
  const { t } = useTranslation('common');

  function SQPData({ lengthEnabled }) {
    const sqpRef = useRef(null);
    const [{ item, handlerId, isOver }, drop] = useDrop({
      accept: 'container',
      drop: () => {
        dropLocation(index, item);
      },
      collect: (monitor) => ({
        item: monitor.getItem(),
        handlerId: monitor.getHandlerId(),
        isOver: monitor.isOver(),
      }),
    });
    const [{ itemDragging }] = useDrag({
      type: 'container',
      collect: (monitor) => ({
        itemDragging: monitor.getItem(),
      }),
    });
    drop(sqpRef);
    return (
      <div ref={sqpRef} data-handler-id={handlerId} key={`SQP_${index}`}>
        {isOver && <div className="potemplate-drag-placeholder">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SIZE_QUANTITY_PRICE.DROP_SECTION_HERE')}</div>}
        <Card className="listing-card">
          <Card.Header className="px-2 py-2 bgcolor-dark">
            <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SIZE_QUANTITY_PRICE.SIZE_QUANTITIES_PRICE')}</strong>
          </Card.Header>
          {itemDragging?.type !== 'container' && (
            <Card.Body className="py-4">
              <SinglePackUnit lengthEnabled={lengthEnabled} data={data} fromAddEdit={fromForm} forSwitch={forSwitch} />
              <MultiSingleSizePackUnit lengthEnabled={lengthEnabled} data={data} fromAddEdit={fromForm} forSwitch={forSwitch} />
              <MultiSizePackUnits lengthEnabled={lengthEnabled} data={data} fromAddEdit={fromForm} forSwitch={forSwitch} />
              <MultiDestinationPackUnits lengthEnabled={lengthEnabled} data={data} fromAddEdit={fromForm} forSwitch={forSwitch} />
            </Card.Body>
          )}
        </Card>
      </div>
    );
  }

  return (
    <DndProvider backend={HTML5Backend}>
      {fromForm ? (
        <SQPData lengthEnabled={lengthEnabled} />
      ) : (
        <Card className="listing-card">
          <Card.Header className="px-2 py-2 bgcolor-dark">
            <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SIZE_QUANTITY_PRICE.SIZE_QUANTITIES_PRICE')}</strong>
          </Card.Header>
          <Card.Body className="py-4">
            <SinglePackUnit lengthEnabled={lengthEnabled} data={data} fromAddEdit={fromForm} forSwitch={forSwitch} />
            <MultiSingleSizePackUnit lengthEnabled={lengthEnabled} data={data} fromAddEdit={fromForm} forSwitch={forSwitch} />
            <MultiSizePackUnits lengthEnabled={lengthEnabled} data={data} fromAddEdit={fromForm} forSwitch={forSwitch} />
            <MultiDestinationPackUnits lengthEnabled={lengthEnabled} data={data} fromAddEdit={fromForm} forSwitch={forSwitch} />
          </Card.Body>
        </Card>
      )}
    </DndProvider>
  );
}

export default SizeQuantityandPrices;
